<template>
  <div>
    <header>
      <div class="burger" @click="toggleChange();">
        <span class="glyphicon glyphicon-menu-hamburger"></span>
      </div>
      <div class="header-title">NICE D&amp;B Administrator</div>
      <div v-if="admYn === 'Y' && userId !== '' && isOtpSuccess">
      <div class="header-logout"><a href="#" onclick="logout();">로그아웃</a></div>
      </div>
    </header>
    <!-- body-container -->
    <form id="logiForm" method="post"></form>
    <section>
      <nav :class="{'gnb-display': toggleFlag}">
        <ul class="gnb">
          <!-- <li class="current"><a href="/admin/ep/employment-list.do?cm_cd=9300&adm_yn=Y">채용공고</a></li> -->
          <li v-if="getUserGrade == 'NDH1001' || getUserGrade == 'NDH1002'"><a href="/admin/cs/cs-notice01-list.do?">공지사항</a></li>
          <li v-if="getUserGrade == 'NDH1001' || getUserGrade == 'NDH1002'"><a href="/admin/pc/pc-presPls01-list.do">보도자료</a></li>
          <li v-if="getUserGrade == 'NDH1001' || getUserGrade == 'NDH1002'"><a href="/admin/im/im-ir01-list.do">IR자료실</a></li>
          <li v-if="getUserGrade == 'NDH1001' || getUserGrade == 'NDH1002'"><a href="/admin/pc/pc-photo01-list.do">사진자료</a></li>
          <li v-if="getUserGrade == 'NDH1001' || getUserGrade == 'NDH1003' || getUserGrade == 'NDH1004' || getUserGrade == 'NDH1005'">
            <a href="#">전자민원</a>
            <ul>
              <li><a href="/admin/cs/cs-minwon01-list.do/POT">(기업) 포털사이트 내 기업보고서 삭제요청</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/CRE">(기업) 열람/정정 청구</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/PRE">(개인) 열람/정정/삭제 청구</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/CIU">(개인) 이용 및 제공사실 조회</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/OFF">(개인) 신용조회사실의 통지 요청</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/RIC">(개인) 상거래 고지 거절</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/DPD">(개인) 거래종료 삭제요구</a></li>
              <li><a href="/admin/cs/cs-minwon01-list.do/CWD">(개인) 동의 철회/마케팅 중지</a></li>
            </ul>
          </li>
          <li v-if="getUserGrade == 'NDH1001' || getUserGrade == 'NDH1003' || getUserGrade == 'NDH1004' || getUserGrade == 'NDH1005'"><a href="/admin/cs/cs-minwon02-list.do/ASO">제휴문의</a></li>
        </ul>
      </nav>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      toggleFlag: false
    };
  },
	components: {
	},
  computed: {
    ...mapGetters("userStore", ["getUserGrade"])
  },
  props: {
    admYn: String,
    userId: String,
    isOtpSuccess: Boolean
  },
  methods: {
    toggleChange() {
      this.toggleFlag = !this.toggleFlag;
    },
    async goMinwonView(regTyp) {
      this.$router.push({name: "minwon01List", params: {regTyp:regTyp}});
    },
  },
};
</script>
